import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import Blockv from '../../managers/blockv';
import styles from './index.module.scss';

class Captcha extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, error: false, image: '' };
  }

  componentDidMount() {
    this.load();
  }

  async load() {
    if (!this.loadPromise)
      this.loadPromise = new Promise((resolve) => {
        this.setState({ loading: true, error: false });
        resolve();
      })
        .then(() => Blockv.publisher.getCaptcha())
        .then((payload) => {
          const { onLoad } = this.props;
          onLoad?.(() => this.load(), payload.id);
          this.setState({ loading: false, error: false, image: payload.image });
          this.loadPromise = null;
        })
        .catch((error) => {
          console.log(error);
          this.setState({ loading: false, error: true });
          this.loadPromise = null;
        });

    return this.loadPromise;
  }

  render() {
    const { style, className, t } = this.props;
    const { loading, error, image } = this.state;
    return (
      <div style={style} className={clsx(styles.container, className)}>
        {loading && <Typography className={styles.loader}>{t('captcha.loading')}</Typography>}
        {error && <Typography className={styles.loader}>{t('captcha.error')}</Typography>}
        {!loading && !error && (
          <>
            <img alt="" src={image} />
            <Button onClick={() => this.load()}>{t('captcha.reload')}</Button>
          </>
        )}
      </div>
    );
  }
}

export default withTranslation()(Captcha);
